import React, { useState } from "react";

import {
  Table,
  Icon,
  Modal,
  ModalBody,
  ModalHeader,
  Alert,
  Chip,
} from "design-react-kit";
import AuthModuleErrorsModal from "./AuthModuleErrorsModal";
import { showFlowType } from "../../services/helpers";

const FlowHistoryModal = ({
  modalOpen,
  modalCloseHandler,
  historyData,
  downloadFileHandler,
  showStatus,
  error,
  page,
  flowName,
  clientCodeName,
}) => {
  const [selectedFlow, setSelectedFlow] = useState(null);
  const [authFlowErrorsModalOpen, setAuthFlowErrorsModalOpen] = useState(false);

  const authFlowErrorsModalOpenHandler = (flow) => {
    setAuthFlowErrorsModalOpen(true);
    setSelectedFlow(flow);
  };

  const authFlowErrorsModalCloseHandler = () => {
    setAuthFlowErrorsModalOpen(false);
    setSelectedFlow(null);
  };

  return (
    <Modal
      isOpen={modalOpen}
      toggle={modalCloseHandler}
      align="center"
      scrollable
      labelledBy="history"
      id="table-modal"
    >
      <ModalHeader
        toggle={modalCloseHandler}
        id="history"
        className="d-flex align-items-start flex-row-reverse w-100"
      >
        <div className="d-flex align-items-start justify-content-between w-100">
          {page === "flowsHistory" && <p>Storico</p>}
          {page === "stagedArchive" && <p>CRONOLOGIA STATI</p>}
          <p>Dettaglio flusso</p>
        </div>
      </ModalHeader>
      {error !== null && error.length !== undefined && (
        <ModalBody>
          <Alert color="danger">
            {error.map((item) => (
              <p key={item}>{item}</p>
            ))}
          </Alert>
        </ModalBody>
      )}
      {historyData !== null && historyData !== undefined && error === null && (
        <ModalBody>
          <div className="mb-3 d-flex flex-column flex-md-row align-items-start justify-content-between">
            <div className="mb-3">
              <p>Tipologia Servizio:</p>
              {page === "flowsHistory" && (
                <p style={{ color: "#0073e6 " }}>
                  {historyData.clientServiceDescription}
                </p>
              )}
              {page === "stagedArchive" && (
                <p style={{ color: "#0073e6 " }}>{clientCodeName}</p>
              )}
            </div>
            {page === "stagedArchive" && (
              <div>
                <div className="d-flex flex-column flex-md-row align-items-start mb-3">
                  <p className="d-inline d-md-block mr-3">
                    Autorizzazione Tecnica:
                  </p>
                  {historyData.hasTechnicalCheck ? (
                    <Chip color="success" className="text-nowrap ml-4">
                      Attivato
                    </Chip>
                  ) : (
                    <Chip color="danger" className="text-nowrap">
                      Non attivato
                    </Chip>
                  )}
                </div>
                <div className="d-flex flex-column flex-md-row align-items-start">
                  <p className="d-inline d-md-block mr-3">
                    Autorizzazione Finanziaria:
                  </p>
                  {historyData.hasEconomicalCheck ? (
                    <Chip color="success" className="text-nowrap">
                      Attivato
                    </Chip>
                  ) : (
                    <Chip color="danger" className="text-nowrap">
                      Non attivato
                    </Chip>
                  )}
                </div>
              </div>
            )}
          </div>

          <div className="d-flex flex-column align-items-start justify-content-between w-100">
            <div className="mb-3">
              <p className="d-inline d-md-block mr-3">
                Flusso{" "}
                {page === "stagedArchive" && (
                  <span>
                    (
                    {historyData.countDigNotifications +
                      historyData.countAnNotifications}{" "}
                    notifiche):
                  </span>
                )}
              </p>
              {page === "stagedArchive" && (
                <>
                  <h5 className="d-inline d-md-block">{flowName}</h5>
                </>
              )}
              {page === "flowsHistory" && (
                <h5 className="d-inline d-md-block">{historyData.flowName}</h5>
              )}
            </div>
          </div>
          {page === "flowsHistory" && (
            <div className="d-flex align-items-center justify-content-between">
              <div className="mb-3 d-flex flex-column flex-md-row align-items-start justify-content-between">
                <div className="mb-3">
                  <p className="d-inline d-md-block mr-3">Stato:</p>
                  {showStatus(
                    historyData.flowStatus,
                    historyData.flowStatusLong,
                  )}
                </div>
              </div>
              <div className="mb-3 d-flex flex-column flex-md-row align-items-start justify-content-between">
                <div className="mb-3">
                  <p className="d-inline d-md-block mr-3">Formato:</p>
                  {showFlowType(historyData.flowType)}
                </div>
              </div>
            </div>
          )}

          {page === "stagedArchive" && (
            <>
              <div className="d-flex align-items-center justify-content-between">
                <div>
                  <p className="d-inline d-md-block mb-2">
                    Conteggio Notifiche Digitali:
                    <span style={{ color: "#0073e6", marginLeft: ".6rem" }}>
                      {historyData.countDigNotifications}
                    </span>
                  </p>
                  <p className="d-inline d-md-block mb-4">
                    Conteggio Notifiche Analogiche:
                    <span style={{ color: "#0073e6", marginLeft: ".6rem" }}>
                      {historyData.countAnNotifications}
                    </span>
                  </p>
                </div>
                <div>
                  <p className="d-inline d-md-block mb-2">
                    Costo Calcolato Notifiche Digitali:
                    <span style={{ color: "#0073e6", marginLeft: ".6rem" }}>
                      {historyData.totalPlatformCost == null
                        ? 0
                        : historyData.totalPlatformCost.toFixed(2)}
                      €
                    </span>
                  </p>

                  <p className="d-inline d-md-block mb-4">
                    Costo Calcolato Notifiche Analogiche:
                    <span style={{ color: "#0073e6", marginLeft: ".6rem" }}>
                      {historyData.totalAnalogicalCost == null
                        ? 0
                        : historyData.totalAnalogicalCost.toFixed(2)}
                      €
                    </span>
                  </p>
                </div>
              </div>
              <div className="d-flex align-items-start justify-content-between">
                <div>
                  <p className="d-inline d-md-block mb-2">
                    Coeff. (costi notifiche digitali):
                    <span style={{ color: "#0073e6", marginLeft: ".6rem" }}>
                      {historyData.digitalCoefficient}
                    </span>
                  </p>
                  <p className="d-inline d-md-block mb-4">
                    Coeff. (costi notifiche analogiche):
                    <span style={{ color: "#0073e6", marginLeft: ".6rem" }}>
                      {historyData.analogicalCoefficient}
                    </span>
                  </p>
                </div>
                <div>
                  <p className="d-inline d-md-block mb-2">
                    Costo componente piattaforma:
                    <span style={{ color: "#0073e6", marginLeft: ".6rem" }}>
                      {(
                        historyData.digitalCoefficient *
                        (historyData.countAnNotifications +
                          historyData.countDigNotifications)
                      ).toFixed(2)}
                      €
                    </span>
                  </p>
                  <p className="d-inline d-md-block mb-2 mr-3">
                    Costo Totale Notifiche Analogiche:
                    <span style={{ color: "#0073e6", marginLeft: ".6rem" }}>
                      {(
                        historyData.analogicalCoefficient *
                        historyData.totalAnalogicalCost
                      ).toFixed(2)}
                      €
                    </span>
                  </p>
                  <p className="d-inline d-md-block mb-4">
                    Costo Totale Notifiche:
                    <span style={{ color: "#0073e6", marginLeft: ".6rem" }}>
                      {(
                        historyData.analogicalCoefficient *
                          historyData.totalAnalogicalCost +
                        historyData.digitalCoefficient *
                          (historyData.countAnNotifications +
                            historyData.countDigNotifications)
                      ).toFixed(2)}
                      €
                    </span>
                  </p>
                </div>
              </div>
            </>
          )}
          <Table responsive className="table mb-0">
            <thead>
              {page === "flowsHistory" && (
                <tr>
                  <th>Lavorazione</th>
                  <th>Data inizio</th>
                  <th>Data fine</th>
                  <th>Report</th>
                </tr>
              )}
              {page === "stagedArchive" && (
                <tr>
                  <th>Data stato</th>
                  <th>Stato</th>
                  <th>Utente</th>
                </tr>
              )}
            </thead>
            {page === "flowsHistory" && (
              <tbody>
                {historyData.flowProcesses.map((item, i) => {
                  return (
                    <tr key={item.workerDescription + i}>
                      <td className="workerDescription">
                        {item.workerDescription}
                      </td>
                      <td className="startTime">{item.startTime}</td>
                      <td className="endTime">{item.endTime}</td>
                      <td title="Download report" className="download">
                        {item.resultFile !== "" && (
                          <Icon
                            icon="it-download"
                            fill="#06c"
                            role="button"
                            onClick={(e) =>
                              downloadFileHandler(
                                encodeURIComponent(item.resultFile),
                                historyData.code,
                              )
                            }
                          />
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            )}
            {page === "stagedArchive" && (
              <tbody>
                {historyData.stagedFlowHistoryStatuses.map((item) => {
                  return (
                    <tr key={item.id}>
                      <td className="statusDate">{item.modifiedOn}</td>
                      <td className="status">
                        {showStatus(item, authFlowErrorsModalOpenHandler)}
                      </td>
                      <td className="managedBy">{item.modifiedBy}</td>
                    </tr>
                  );
                })}
              </tbody>
            )}
          </Table>
          <AuthModuleErrorsModal
            modalOpen={authFlowErrorsModalOpen}
            modalCloseHandler={authFlowErrorsModalCloseHandler}
            selectedFlow={selectedFlow}
            isArchivePage={true}
          />
        </ModalBody>
      )}
    </Modal>
  );
};

export default FlowHistoryModal;
